import React from 'react';

function LegalText(props) {

    return (

        <div className={props.className || "legal"}>
            * Angebote richten sich ausschließlich an Gewerbetreibende. Alle Preise zzgl. Umsatzsteuer.<br key="br"/>
            (Bitte beachten Sie, dass im EU-Ausland für elektronische Dienstleistungen andere Steuersätze gelten können.)
        </div>

    )

}

LegalText.propTypes = {};

export default LegalText



/** WEBPACK FOOTER **
 ** ./src/components/LegalText.js
 **/